import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback, createContext, useContext } from 'react';
const ToastContext = createContext(null);
export function useToast() {
    const ctx = useContext(ToastContext);
    if (!ctx)
        throw new Error('useToast must be used within ToastProvider');
    return ctx;
}
const MAX_TOASTS = 3;
const typeColors = {
    success: 'var(--color-success)',
    error: 'var(--color-danger)',
    warning: 'var(--color-warning)',
    info: 'var(--color-info)',
};
export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);
    const toast = useCallback((message, type = 'info', duration = 5000) => {
        const id = crypto.randomUUID();
        setToasts((prev) => [...prev.slice(-(MAX_TOASTS - 1)), { id, type, message, duration }]);
    }, []);
    const dismiss = useCallback((id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    }, []);
    return (_jsxs(ToastContext.Provider, { value: { toast }, children: [children, _jsx("div", { style: {
                    position: 'fixed',
                    bottom: 'var(--space-6)',
                    right: 'var(--space-6)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 'var(--space-2)',
                    zIndex: 9999,
                }, children: toasts.map((t) => (_jsx(ToastItem, { item: t, onDismiss: dismiss }, t.id))) })] }));
}
function ToastItem({ item, onDismiss }) {
    useEffect(() => {
        if (item.duration > 0) {
            const timer = setTimeout(() => onDismiss(item.id), item.duration);
            return () => clearTimeout(timer);
        }
    }, [item.id, item.duration, onDismiss]);
    return (_jsxs("div", { role: "alert", style: {
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--space-3)',
            padding: 'var(--space-3) var(--space-4)',
            background: 'var(--color-bg-elevated)',
            border: '1px solid var(--color-border)',
            borderLeft: `3px solid ${typeColors[item.type]}`,
            borderRadius: 'var(--radius-md)',
            boxShadow: 'var(--shadow-lg)',
            fontSize: 'var(--text-caption)',
            fontFamily: 'var(--font-body)',
            color: 'var(--color-text)',
            minWidth: '280px',
            maxWidth: '400px',
            animation: 'slideIn 200ms var(--easing-default)',
        }, children: [_jsx("span", { style: { flex: 1 }, children: item.message }), _jsx("button", { onClick: () => onDismiss(item.id), "aria-label": "Dismiss notification", style: {
                    background: 'none',
                    border: 'none',
                    color: 'var(--color-text-faint)',
                    cursor: 'pointer',
                    padding: '2px',
                    fontSize: '16px',
                    lineHeight: 1,
                }, children: "\u00D7" })] }));
}
//# sourceMappingURL=Toast.js.map